import api from "./api";

class Me {

    me(){
        return api.get(`/me`)
    }

    clienti(config?: any){
        return api.get(`me/clienti`, config)
    }

    permissions(){
        return api.get(`me/permissions`)
    }

    groups(){
        return api.get(`me/groups`)
    }

    alertsManuali(cliente_id:string|number){
        return api.get(`/me/${cliente_id}/alerts_manuali`)
    }

    alertsAutomatici(cliente_id:string|number){
        return api.get(`/me/${cliente_id}/alerts_automatici`)
    }

    logout(){
        return api.post('/logout')
    }

    loginAsUser(user_email:string){
        return api.post('/login_as_user', {email: user_email})
    }

    counters(){
        return api.get(`/me/counters`)
    }

    notifications(){
        return api.get(`/me/notifiche`)
    }

    sottoprogettoPreference(sottoprogetto_id: string|number){
        return api.get(`/me/sottoprogetto_preference/${sottoprogetto_id}`)
    }

    syncSottoprogettoPreference(sottoprogetto_id: string|number, data:any){
        return api.post(`/me/sottoprogetto_preference/${sottoprogetto_id}`, data)
    }


    retrieve = this.me
    list = this.clienti
    paginatedList = this.clienti
}

const meManager = new Me()

export default meManager
